import { render, staticRenderFns } from "./RegionalModule.vue?vue&type=template&id=4b104d4c"
import script from "./RegionalModule.vue?vue&type=script&lang=js"
export * from "./RegionalModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports